var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "min-height": "35rem"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "request-title"
  }, [_vm._v("Request Certificate of Property Insurance")]), _vm._v(" "), (_vm.stage === 1) ? _c('AssociationPin', {
    attrs: {
      "hasTenant": _vm.hasTenant,
      "agencies": _vm.agencies,
      "Request": _vm.Request,
      "showNotFound": _vm.showNotFound
    },
    on: {
      "tenantSelected": _vm.tenantSelected,
      "next": _vm.getAssociation,
      "cancel": _vm.cancel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 2) ? _c('PropertyInformation', {
    attrs: {
      "Request": _vm.Request
    },
    on: {
      "next": _vm.next,
      "previous": _vm.previous,
      "cancel": _vm.cancel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 3) ? _c('FinalizeRequest', {
    attrs: {
      "Request": _vm.Request
    },
    on: {
      "finalize": _vm.finalize,
      "previous": _vm.previous,
      "cancel": _vm.cancel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 4) ? _c('RequestComplete', {
    attrs: {
      "accord24": _vm.Request.Association.Accord24,
      "association": _vm.Request.Association
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tenantLongName != null && _vm.tenantPhoneNumber != null) ? _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "has-text-centered has-text-grey is-size-6",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Questions or issues? Call " + _vm._s(_vm.tenantLongName) + " at " + _vm._s(_vm.tenantPhoneNumber) + ".")])]) : _vm._e()], 1)]), _vm._v(" "), _c('Footer')], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61c7d280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/request/Request.vue
// module id = JDfm
// module chunks = 1